module.exports = __webpack_public_path__ + "static/media/TWSScreen.ba22d350.png";